// sidebar
const sideBarIconSize = "1.5rem";
const ICON_SIZE_LARGE = "1.5rem";
const sideBarProfileSize = "2.5rem";
const sideBarMargin = "2rem";
const sideBarWidth = `calc(${sideBarMargin} + ${sideBarIconSize} + ${sideBarMargin})`;
const sideBarProfileMargin = `calc((${sideBarWidth} - ${sideBarProfileSize}) / 2)`;
const expandedSideBarWidth = "21rem";
// const sideBarMargin = "1.5rem";
const SIDEBAR_WIDTH = "4.5rem";
// const sideBarProfileMargin = `calc((${SIDEBAR_WIDTH} - ${sideBarProfileSize}) / 2)`;
const SIDEBAR_WIDTH_EXPANDED = "20rem";
const sideBarAnimationDuration = "0.3s";

// layout
const DefaultLayoutMargin = "1rem";
const DefaultLayoutPadding = "3rem";

// sidebar, height
const HEADER_HEIGHT = "4.5rem";

// component
const defaultComponentHeight = "3rem";
const buttonHeight = defaultComponentHeight;
// const buttonHeight = "3.25rem"; //TODO:delete later
const largeComponentHeight = "3.25rem";
const smallButtonHeight = "2.375rem"; //TODO:delete later
const smallComponentHeight = "2.375rem";
const fieldHeight = `calc(${defaultComponentHeight} - 2*var(--border-width))`;

const inputValidTargetAttrName = "valid-type";
const inputValidTargetAttrTitle = "valid-title";

export const convertToPx = (
  value,
  parentElement = document.documentElement
) => {
  if (typeof value !== "string") return parseFloat(value);

  if (value.endsWith("rem")) {
    const remValue = parseFloat(value);
    const rootFontSize = parseFloat(
      getComputedStyle(document.documentElement).fontSize
    );
    return remValue * rootFontSize;
  }

  if (value.endsWith("%")) {
    return value;
  }

  return parseFloat(value);
};
export {
  HEADER_HEIGHT,
  sideBarMargin,
  sideBarIconSize,
  // ICON_SIZE_LARGE,
  sideBarProfileSize,
  sideBarProfileMargin,
  sideBarWidth,
  expandedSideBarWidth,
  SIDEBAR_WIDTH,
  SIDEBAR_WIDTH_EXPANDED,
  sideBarAnimationDuration,
  DefaultLayoutMargin,
  DefaultLayoutPadding,
  defaultComponentHeight,
  buttonHeight,
  smallButtonHeight,
  largeComponentHeight,
  smallComponentHeight,
  fieldHeight,
  inputValidTargetAttrName,
  inputValidTargetAttrTitle,
};
